import Button from '@rio-cloud/rio-uikit/Button';
import FilePicker from '@rio-cloud/rio-uikit/FilePicker';
import { useIntl } from 'react-intl';

type CsvImportFilePickerProps = {
    selectedFileName?: string;
    onFileSelected: (file?: File) => Promise<void>;
    onReset: () => void;
};

export const CsvImportFilePicker = ({ selectedFileName, onFileSelected, onReset }: CsvImportFilePickerProps) => {
    const intl = useIntl();

    const renderDropArea = ({ isDragActive }: { isDragActive: boolean }) => (
        <div
            className={`
                rounded border border-style-dashed border-color-gray bg-lightest text-size-14
                text-center text-color-darker opacity-50 padding-25 cursor-pointer min-height-200
                display-grid place-items-center
            `}
        >
            <div>
                <span className='uikit-icon icon-files text-size-200pct opacity-50' />
                <div className='margin-top-10 text-size-18'>
                    {isDragActive
                        ? intl.formatMessage({
                              id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.action',
                          })
                        : intl.formatMessage({
                              id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.title',
                          })}
                </div>
            </div>
        </div>
    );

    if (!selectedFileName) {
        return (
            <FilePicker
                data-testid='csv-import-file-input'
                displayMode='dropzone'
                className='width-100pct'
                accept={{
                    'text/csv': ['.csv'],
                    'application/vnd.ms-excel': ['.csv'],
                }}
                multiple={false}
                onPick={(acceptedFiles: File[]) => {
                    void onFileSelected(acceptedFiles[0]);
                }}
                fullHeight
            >
                {renderDropArea}
            </FilePicker>
        );
    }

    return (
        <div className='panel panel-default position-relative margin-top-10 margin-bottom-10'>
            <div className='panel-heading border-none text-size-16 line-height-125rel word-break-all'>
                <b>{selectedFileName}</b>
            </div>
            <Button
                type='button'
                bsStyle={Button.UNSTYLED}
                iconOnly
                iconName='remove'
                noRippleEffect
                autoTrackingKey='ordercom.orders.csv-import.remove-file'
                className={
                    'width-20 aspect-ratio-1 rounded-circle bg-white border border-color-light ' +
                    'display-grid place-items-center cursor-pointer position-absolute top-0 right-0 ' +
                    'translate-x50pct-y-50pct padding-0 text-size-12'
                }
                aria-label='Remove selected CSV file'
                onClick={onReset}
            />
        </div>
    );
};
